import router from '@/router'
// import store from '@/store'
import { Cache } from '@/util/cache'
const cache = new Cache()
const AppEvents = [
  {
    name: 'APP_LOGIN_SUCCESS',
    callback: () => {
      router.push({ path: '/welcome' })
    }
  },
  {
    name: 'APP_LOGOUT',
    callback: () => {
      cache.removeAccessToken()
      router.replace({ path: '/sign-in' })
    }
  },
  {
    name: 'APP_PAGE_LOADED',
    callback: () => {}
  },
  {
    name: 'APP_AUTH_FAILED',
    callback: () => {
      router.push('/sign-in')
      this.$message.error('Token has expired')
    }
  },
  {
    name: 'APP_BAD_REQUEST',
    callback: msg => {
      this.$message.error(msg)
    }
  },
  {
    name: 'APP_ACCESS_DENIED',
    callback: msg => {
      this.$message.error(msg)
      router.push('/forbidden')
    }
  },
  {
    name: 'APP_RESOURCE_DELETED',
    callback: msg => {
      this.$message.success(msg)
    }
  },
  {
    name: 'APP_RESOURCE_UPDATED',
    callback: msg => {
      this.$message.success(msg)
    }
  }
]

export { AppEvents }
